// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lightbox:not(.lightbox.fullscreen) {
  --height: 70vh;
  height: var(--height);
  position: relative;
  cursor: pointer;
}
.fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100vw;
  --heightFS: 100vh;
  height: var(--heightFS);
  padding: 50px;
  background-color: rgba(0, 0, 0, 0.624);
}
.fullscreenBtn {
  position: absolute;
  right: 24px;
  top: 24px;
  background-color: white;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  display: flex;
  border-radius: 50px;
  cursor: pointer;
  z-index: 10;
}
.currentThumbnail {
  filter: grayscale(100%);
}
.thumbnailContainer {
  width: 200px;
  cursor: pointer;
  flex-shrink: 0;
  overflow: hidden;
  transition-duration: 0.2s;
  margin: 5px;
  border-radius: 8px;
}
.thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition-duration: 0.2s;
  user-drag: none;
  -webkit-user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  /* padding: 5px; */
  box-sizing: border-box;
  box-shadow: var(--box-shadow);
}
.thumbnail:hover {
  transform: scale(1.1);
}
.displayedImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* margin: 5px; */
  border-radius: 8px;
  box-shadow: var(--box-shadow);
}

.lightboxTop {
  height: 80%;
  transition-duration: 0.3s;
  padding: 5px;
}
.lightboxBottom {
  height: 20%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: scroll;
}
.fadeOut {
  opacity: 0;
}
.fadeIn {
  opacity: 1;
}
.lightBoxBtn {
  position: absolute;
  background-color: white;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 200px;
  top: calc((var(--height) * 0.8 - 20px) / 2);
  cursor: pointer;
  z-index: 10;
}
.lightBoxBtn.left {
  left: 24px;
}
.lightBoxBtn.right {
  right: 24px;
}

/* button hover effects */
.lightBoxBtn, .fullscreenBtn {
  transition: transform 0.1s ease 0s;
}

.lightBoxBtn:hover, .fullscreenBtn:hover {
  transform: scale(1.08);
}

.fullscreen .lightBoxBtn {
  top: calc((var(--heightFS) * 0.8 - 20px) / 2);
}
`, "",{"version":3,"sources":["webpack://./src/css/ImageLightbox.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,2CAA2C;EAC3C,eAAe;EACf,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;AAC/C","sourcesContent":[".lightbox:not(.lightbox.fullscreen) {\n  --height: 70vh;\n  height: var(--height);\n  position: relative;\n  cursor: pointer;\n}\n.fullscreen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  width: 100vw;\n  --heightFS: 100vh;\n  height: var(--heightFS);\n  padding: 50px;\n  background-color: rgba(0, 0, 0, 0.624);\n}\n.fullscreenBtn {\n  position: absolute;\n  right: 24px;\n  top: 24px;\n  background-color: white;\n  width: 40px;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  border-radius: 50px;\n  cursor: pointer;\n  z-index: 10;\n}\n.currentThumbnail {\n  filter: grayscale(100%);\n}\n.thumbnailContainer {\n  width: 200px;\n  cursor: pointer;\n  flex-shrink: 0;\n  overflow: hidden;\n  transition-duration: 0.2s;\n  margin: 5px;\n  border-radius: 8px;\n}\n.thumbnail {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition-duration: 0.2s;\n  user-drag: none;\n  -webkit-user-drag: none;\n  user-select: none;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  /* padding: 5px; */\n  box-sizing: border-box;\n  box-shadow: var(--box-shadow);\n}\n.thumbnail:hover {\n  transform: scale(1.1);\n}\n.displayedImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  /* margin: 5px; */\n  border-radius: 8px;\n  box-shadow: var(--box-shadow);\n}\n\n.lightboxTop {\n  height: 80%;\n  transition-duration: 0.3s;\n  padding: 5px;\n}\n.lightboxBottom {\n  height: 20%;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  overflow-x: scroll;\n}\n.fadeOut {\n  opacity: 0;\n}\n.fadeIn {\n  opacity: 1;\n}\n.lightBoxBtn {\n  position: absolute;\n  background-color: white;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 200px;\n  top: calc((var(--height) * 0.8 - 20px) / 2);\n  cursor: pointer;\n  z-index: 10;\n}\n.lightBoxBtn.left {\n  left: 24px;\n}\n.lightBoxBtn.right {\n  right: 24px;\n}\n\n/* button hover effects */\n.lightBoxBtn, .fullscreenBtn {\n  transition: transform 0.1s ease 0s;\n}\n\n.lightBoxBtn:hover, .fullscreenBtn:hover {\n  transform: scale(1.08);\n}\n\n.fullscreen .lightBoxBtn {\n  top: calc((var(--heightFS) * 0.8 - 20px) / 2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
